<template>
  <div id="app">
    <v-app id="inspire">
      <v-row
        class="supplier-detail custom-border-top mt-3"
        v-if="engineer.leaves.length > 0"
      >
        <v-col md="12" sm="12" class="pt-4">
          <v-skeleton-loader
            class="custom-skeleton"
            v-if="pageLoading"
            type="table-tbody"
          >
          </v-skeleton-loader>
          <v-simple-table v-else class="simple-table">
            <template v-slot:default>
              <thead>
                <tr style="background-color: #f3f6f9; color: #24326d">
                  <!-- <td>
                           
                        </td> -->
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Leave Type
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Allowedd Leaves
                  </td>
                  <td class="font-size-13 text-uppercase font-weight-500">
                    Used Leaves
                  </td>

                  <td class="font-size-13 text-uppercase font-weight-500">
                    Balance Leaves
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(leave, index) in engineer.leaves"
                  :key="index"
                  :class="{
                    'custom-border-top': index == 0,
                    'orange_lighten-5': index % 2 == 0,
                  }"
                >
                  <!-- <td>
                          <v-checkbox v-model="selectedRows" class="hide-margin" color="cyan" dense hide-details
                            v-bind:value="leave.id"></v-checkbox>
                        </td> -->

                  <td link class="font-size-14 font-weight-500">
                    <template v-if="leave && leave.leave_title">
                      <v-chip
                        class="mx-2 custom-status font-weight-600 custom-grey-border text-uppercase justify-center font-10"
                        color="blue darken-1"
                        label
                        small
                        text-color="white"
                      >
                        {{ leave.leave_title }}
                      </v-chip>
                      <br />
                    </template>
                    <em v-else class="text-muted">no leave type</em>
                  </td>

                  <td link class="font-size-14 font-weight-500 text-lowercase">
                    <template v-if="leave && leave.leave_allowed">
                      <v-avatar class="white--text" color="green" size="26">
                        {{ leave.leave_allowed }}
                      </v-avatar>
                    </template>
                    <em v-else class="text-muted"> no leave allowed</em>
                  </td>

                  <td class="font-size-14 font-weight-500">
                    <template v-if="leave && leave.leave_used">
                      <v-avatar class="white--text" color="primary" size="26">
                        {{ leave.leave_used }}
                      </v-avatar>
                    </template>
                    <em v-else class="text-muted"> no leave used</em>
                  </td>
                  <td class="simple-table-td">
                    <template v-if="leave && leave.leave_balance">
                      <v-avatar class="white--text" color="red" size="26">
                        {{ leave.leave_balance }}
                      </v-avatar>
                    </template>
                    <em v-else class="text-muted"> no leave used</em>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>

      <v-col class="text-center border-top" v-else>
        <p class="m-0 py-15 row-not-found text-center">
          <img
            :src="$assetURL('media/error/empty.png')"
            class="row-not-found-image"
          />
          Uhh... There are no detail at the moment.
        </p>
      </v-col>
    </v-app>
  </div>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";

import ValidationMixin from "@/core/plugins/validation-mixin";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "login-log",
  props: {
    engineer: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
  },

  mounted() {
    this.getLeaveTypes();
  },
};
</script>
